import { render, staticRenderFns } from "./ServiceIntegrationUsers.vue?vue&type=template&id=baba5ef0&scoped=true&"
import script from "./ServiceIntegrationUsers.vue?vue&type=script&lang=js&"
export * from "./ServiceIntegrationUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baba5ef0",
  null
  
)

export default component.exports